module.exports = __webpack_public_path__ + "static/media/Launchsomthingnew_icon.df2608e2.svg";